export default __webpack_public_path__ + "static/media/ic_file_eadd.3c8c9ef1.svg";